import { render, staticRenderFns } from "./FireThirdPartyList.vue?vue&type=template&id=65613e21&scoped=true"
import script from "./FireThirdPartyList.vue?vue&type=script&lang=ts"
export * from "./FireThirdPartyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65613e21",
  null
  
)

export default component.exports